import { ApiUrl } from "../../../Constants/Api";
import {
  REQUEST_METHOD,
  WebService,
} from "../../WebServiceManager/RequestService";
import TimesheetRequestBody from "./TimesheetRequestBody";

export default class TimeSheetService {
  request = new TimesheetRequestBody();
  static shared = new TimeSheetService();

  timesheetByIdRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared 
        .callServiceApi(
          ApiUrl.getTimeSheetsByProjectId(payload.employee, payload.project, payload.fromDate, payload.page, payload.size,payload.sortby),
          this.request.timesheetByIdRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    }); 
  }
 
  timeSheetsByProjectIdRequestForUserPage = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getTimeSheetsByProjectIdForUserPage(payload.project.id, payload.page, payload.size),
          this.request.timesheetByIdRequestForUserPage(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  
  addNewTimesheetRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.addTimeSheet(),
          this.request.addNewTimesheetRequest(payload, REQUEST_METHOD.POST)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  editTimesheetsRequest =(payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.editTimesheets(payload.id),
          this.request.editTimesheetsRequest({timeSheet: payload.timeSheet, files:payload.files}, REQUEST_METHOD.PUT)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  getTimesheetByIdRequest =(payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getTimesheetById(payload),
          this.request.getTimesheetByIdRequest(payload, REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }


  timesheetsActionRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.timesheetsAction(payload.id, payload.action, payload.remarks),
          this.request.timesheetsActionRequest(REQUEST_METHOD.POST) 
        )
        .then((response) => resolve(response))
        .catch((error) => {
          reject(error);
        });
    });
  };
  
  

  generateInvoiceRequest = (payload ) =>{
    return new Promise ((resolve, reject) =>{
      WebService.clientShared
      .callServiceApi(
        ApiUrl.generateInvoice(),
        this.request.generateInvoiceRequest(payload,REQUEST_METHOD.POST)
      ) 
      .then((response) =>{
        resolve(response);
      })
      .catch((error) =>{
        reject(error);
      })
    })
  }

  downloadInvoiceRequest = (payload) =>{
    return new Promise ((resolve, reject) =>{
      WebService.clientShared
      .callServiceApi(
        ApiUrl.downloadInvoice(payload.id, payload.invoiceId),
        this.request.downloadInvoiceRequest(payload,REQUEST_METHOD.GET),
        true
      )
      .then((response) =>{
        resolve(response);
      })
      .catch((error) =>{
        reject(error);
      })
    })
  }

  downloadTimeSheetRequest = (payload) => {
    return new Promise ((resolve, reject) => {
      WebService.clientShared
      .callServiceApi(
        ApiUrl.downloadTimeSheet(payload),
        this.request.downloadTimeSheetRequest(REQUEST_METHOD.GET)
      )
      .then((response) =>{
        resolve(response);
      })
      .catch((error) =>{
        reject(error);
      })
    })
  }

  timesheetListRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllTimesheet(payload.page, payload.size, payload.employeeName, payload.sortby),
          this.request.timesheetListRequest( REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  timesheetAppRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllTimesheetApp(payload.page, payload.size, payload.search, payload.sortby),
          this.request.timesheetAppRequest( REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
 
  
  rejectedTimesheetsListRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllRejectedTimesheets(payload.page, payload.size, payload.employeeName, payload.sortby),
          this.request.rejectedTimesheetListRequest( REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  toBeInvoicedListRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllToBeInvoicedTimesheets(payload.page, payload.size, payload.employeeName, payload.sortby),
          this.request.toBeInvoicedListRequest( REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  downloadFileByIdRequest = (payload) => {
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.downloadFileById(payload.tId,payload.fileId),
          this.request.downloadFileByIdRequest(REQUEST_METHOD.GET)
        )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  toBeInvoicedTimesheetListByEmployeeAndProjectRequest = (payload) => {
    
    return new Promise((resolve, reject) => {
      WebService.clientShared
        .callServiceApi(
          ApiUrl.getAllToBeInvoicedTimesheetsByEmployeeAndProject(payload.eId, payload.pId,payload.sortby),
          this.request.toBeInvoicedTimesheetListByEmployeeAndProjectRequest(REQUEST_METHOD.GET)
        ) 
        .then((response) => {
          console.log('API call successful:', response);
          resolve(response);
        })
        .catch((error) => {
          console.error('API call failed:', error);
          reject(error);
        });
    });
  }

}